import {getByDotKey} from "../utils";

const validate = (data, rules) => {
    if (typeof rules !== 'object') {
        throw new Error('validate method need an object as second parameters.');
    }

    let errors = {};

    Object.keys(rules).forEach(field => {
        let inputRules = rules[field],
            value = getByDotKey(data, field, '').trim();

        inputRules.every(rule => {
            let [isValid, message, shouldContinue] = rule(value, data);

            if (!isValid) {
                if (!errors[field]) {
                    errors[field] = [];
                }

                errors[field].push(message);
            }

            return shouldContinue;
        });
    });

    return errors;
};

export default validate;